import { convertDatesToISO, getHeaders } from '@/config/aux'
import { DeviceExtraction } from '../models/deviceExtraction'
import { DeviceExtractionStateType } from './state'
import axios from 'axios'

export interface DeviceExtractionActionsType {
  getDeviceExtractions(): Promise<void>
  getDeviceExtractionsByDeviceSettingId(deviceSettingId: string): Promise<void>
  getDeviceExtractionsByType(type: string): Promise<void>
  getActiveDeviceExtractions(): Promise<void>
  getOverdueDeviceExtractions(): Promise<void>
  postDeviceExtraction(deviceExtraction: DeviceExtraction): Promise<void>
  putDeviceExtraction(deviceExtraction: DeviceExtraction): Promise<void>
  deleteDeviceExtraction(id: string): Promise<void>
  syncDeviceExtraction(id: string): Promise<void>
  toggleDeviceExtractionStatus(id: string): Promise<void>
}

export const DeviceExtractionActions = {
  async getDeviceExtractions(this: DeviceExtractionStateType) {
    try {
      this.deviceExtractions = []
      const query = `${process.env.VUE_APP_URL_BASE}/api/admin/device-extractions`
      await axios.get(query, { headers: getHeaders() }).then(response => {
        if (response.status === 200) {
          response.data.forEach((deviceExtraction: DeviceExtraction) => {
            this.deviceExtractions.push(new DeviceExtraction(deviceExtraction))
          })
        }
      })
    } catch (error) {
      console.error('Error getting DeviceExtractions', error)
    }
  },
  async getDeviceExtractionsByDeviceSettingId(this: DeviceExtractionStateType, deviceSettingId: string) {
    try {
      this.deviceExtractions = []
      const query = `${process.env.VUE_APP_URL_BASE}/api/admin/device-extractions/device-setting/${deviceSettingId}`
      await axios.get(query, { headers: getHeaders() }).then(response => {
        if (response.status === 200) {
          response.data.forEach((deviceExtraction: DeviceExtraction) => {
            this.deviceExtractions.push(new DeviceExtraction(deviceExtraction))
          })
        }
      })
    } catch (error) {
      console.error('Error getting DeviceExtractions by deviceSettingId', error)
    }
  },
  async getDeviceExtractionsByType(this: DeviceExtractionStateType, type: string) {
    try {
      this.deviceExtractions = []
      const query = `${process.env.VUE_APP_URL_BASE}/api/admin/device-extractions/type/${type}`
      await axios.get(query, { headers: getHeaders() }).then(response => {
        if (response.status === 200) {
          response.data.forEach((deviceExtraction: DeviceExtraction) => {
            this.deviceExtractions.push(new DeviceExtraction(deviceExtraction))
          })
        }
      })
    } catch (error) {
      console.error('Error getting DeviceExtractions by type', error)
    }
  },
  async getActiveDeviceExtractions(this: DeviceExtractionStateType) {
    try {
      this.deviceExtractions = []
      const query = `${process.env.VUE_APP_URL_BASE}/api/admin/device-extractions/active`
      await axios.get(query, { headers: getHeaders() }).then(response => {
        if (response.status === 200) {
          response.data.forEach((deviceExtraction: DeviceExtraction) => {
            this.deviceExtractions.push(new DeviceExtraction(deviceExtraction))
          })
        }
      })
    } catch (error) {
      console.error('Error getting active DeviceExtractions', error)
    }
  },
  async getOverdueDeviceExtractions(this: DeviceExtractionStateType) {
    try {
      this.deviceExtractions = []
      const query = `${process.env.VUE_APP_URL_BASE}/api/admin/device-extractions/overdue`
      await axios.get(query, { headers: getHeaders() }).then(response => {
        if (response.status === 200) {
          response.data.forEach((deviceExtraction: DeviceExtraction) => {
            this.deviceExtractions.push(new DeviceExtraction(deviceExtraction))
          })
        }
      })
    } catch (error) {
      console.error('Error getting overdue DeviceExtractions', error)
    }
  },
  async postDeviceExtraction(this: DeviceExtractionStateType, deviceExtraction: DeviceExtraction) {
    try {
      const query = `${process.env.VUE_APP_URL_BASE}/api/admin/device-extractions`
      const data = convertDatesToISO(deviceExtraction.toPlainObject())

      await axios.post(query, data, { headers: getHeaders() }).then(response => {
        if (response.status === 201) {
          // this.deviceExtractions.push(deviceExtraction)
        }
      })
    } catch (error) {
      console.error('Error posting DeviceExtraction', error)
    }
  },
  async putDeviceExtraction(this: DeviceExtractionStateType, deviceExtraction: DeviceExtraction) {
    try {
      const query = `${process.env.VUE_APP_URL_BASE}/api/admin/device-extractions`
      const data = convertDatesToISO(deviceExtraction.toPlainObject())

      await axios
        .put(query, data, {
          headers: {
            ...getHeaders(),
            'Content-Type': 'application/json',
          },
        })
        .then(response => {
          if (response.status === 200) {
            //this.deviceExtractions = this.deviceExtractions.map(de => (de.id === deviceExtraction.id ? deviceExtraction : de))
          }
        })
    } catch (error) {
      console.error('Error updating DeviceExtraction', error)
    }
  },
  async deleteDeviceExtraction(this: DeviceExtractionStateType, id: string) {
    try {
      const query = `${process.env.VUE_APP_URL_BASE}/api/admin/device-extractions/${id}`
      await axios.delete(query, { headers: getHeaders() }).then(response => {
        if (response.status === 200) {
          //this.deviceExtractions = this.deviceExtractions.filter(de => de.id !== id)
        }
      })
    } catch (error) {
      console.error('Error deleting DeviceExtraction', error)
    }
  },
  async syncDeviceExtraction(this: DeviceExtractionStateType, id: string) {
    try {
      const query = `${process.env.VUE_APP_URL_BASE}/api/admin/device-extractions/${id}/sync`
      await axios.post(query, {}, { headers: getHeaders() }).then(response => {
        if (response.status === 200) {
          // Actualizar lastSyncAt en el store local
          // this.getDeviceExtractions()
        }
      })
    } catch (error) {
      console.error('Error syncing DeviceExtraction', error)
    }
  },
  async toggleDeviceExtractionStatus(this: DeviceExtractionStateType, id: string) {
    try {
      const query = `${process.env.VUE_APP_URL_BASE}/api/admin/device-extractions/${id}/toggle`
      await axios.post(query, {}, { headers: getHeaders() }).then(response => {
        if (response.status === 200) {
          // Actualizar estado activo en el store local
          // this.getDeviceExtractions()
        }
      })
    } catch (error) {
      console.error('Error toggling DeviceExtraction status', error)
    }
  },
}
